import { DraftConfigurationText, Point } from '@/types';
import { SVG_NS } from './consts';
import { getMeasurer } from './getMeasurer';

export const coordinatesForText = (text: DraftConfigurationText): Point => {
  const svg = getMeasurer();
  const style = text.style;
  const font = style.font;
  const textAlign = style.textAlign;

  const textElement = document.createElementNS(SVG_NS, 'text');
  textElement.setAttribute('text-rendering', 'geometricPrecision');
  textElement.setAttribute('letter-spacing', '0px');

  text.content.split('\n').forEach((line) => {
    const tspan = document.createElementNS(SVG_NS, 'tspan');

    tspan.setAttribute('x', '0');
    tspan.setAttribute('font-size', String(style.fontSize));
    tspan.setAttribute('font-family', font.identifier);
    tspan.setAttribute('font-style', font.style);
    tspan.setAttribute('font-weight', font.weight);
    tspan.setAttribute('style', 'white-space:pre');
    tspan.textContent = line;

    textElement.appendChild(tspan);
  });

  svg.appendChild(textElement);
  const bbox = textElement.getBBox();
  svg.removeChild(textElement);

  const { x: boxX, y: boxY, width: boxWidth } = bbox;

  let x = -boxX;
  if (textAlign === 'center') {
    x = (boxWidth - boxX) / 2;
  } else if (textAlign === 'right') {
    x = boxWidth;
  }

  return {
    x,
    y: -boxY,
  };
};
